import {useEffect, useState} from 'react'
import {useCustomerStore} from './useStore'
import {BonusCardData, BonusCardTransaction} from '../../types/store/customer'
import { useHistory } from 'react-router-dom' 

export const useBonusCard = (loadTransactions: boolean) => {
  const customerStore = useCustomerStore()
  const [cardData, setCardData] = useState<BonusCardData | undefined>()
  const [transactions, setTransactions] = useState<BonusCardTransaction[]>([])
  const [cardNumber, setCardNumber] = useState<string | undefined>(
    customerStore?.bonusCardDataAndTransactions?.cardData?.cardNumber
  )
  const [lastFour, setLastFour] = useState<string | undefined>()
  const [balance, setBalance] = useState<number | bigint >()
  const [bonusCardActive, setBonusCardActive] = useState(false)
  const [isBonusCardServiceActive, setBonusCardServiceActive] = useState(true);
  const[loading, setLoading] =useState<boolean>(true)
  const history = useHistory()

  const getBonusCardData = async () => {
    setLoading(true)
    await customerStore.getBonusCardDataAndTransactions(loadTransactions)
    setLoading(false);
  }

  const isBonusCardActive = (cardData : BonusCardData | undefined) : boolean =>{
    let cardIsActive = true;
    if(!cardData || cardData.onboardingStatus.nominationError){
      cardIsActive = false;
    }
    return cardIsActive
  }

  const setBonusCardData = () => {
    const cardResponse = customerStore.bonusCardDataAndTransactions;
    if (cardResponse?.error){ 
      setBonusCardServiceActive(false);
    }
    const cardData = cardResponse?.cardData
    setCardNumber(cardData?.cardNumber) 
    setCardData(cardData)
    setTransactions(cardResponse?.transactions ?? [])
    setBonusCardActive(isBonusCardActive(cardData))
  }

  useEffect(() => {
    const pathUpdateLocations = [
      '/account/bonus-card',
      '/checkout/summary'
    ]
    const isBonusCardPath = pathUpdateLocations.includes(history.location.pathname)
    if (isBonusCardPath) {
      getBonusCardData()
    }
  }, [history.location.pathname])

  useEffect(() => {
    if(cardNumber){
      setLastFour(cardNumber.slice(-4))
    }
  }, [cardNumber])

  useEffect(() => {
    setBonusCardData()
  }, [customerStore.bonusCardDataAndTransactions])

  useEffect(() => {
    if(cardData?.balance){
      setBalance(cardData.balance)
    }
  }, [cardData])

  return {
    cardData,
    balance,
    transactions,
    cardNumber,
    lastFour,
    setCardNumber,
    loading,
    bonusCardActive,
    getBonusCardData,
    isBonusCardServiceActive
  }
}
